/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

export const SITUATION_COHABITATION = 'cohabitation'
export const SITUATION_MARRIED = 'married'
export const SITUATION_SINGLE = 'single'

export const FamilySituationCodes = [
  SITUATION_COHABITATION,
  SITUATION_MARRIED,
  SITUATION_SINGLE
]
